// An invisible target for a tour step, laid over the top of a section.
//
// A step pointed at a whole section that is taller than what is left of a
// phone screen gives the popover nowhere to go, so the tour library draws it
// on top of the very thing it is describing (the Starters card, the
// standings table). Lighting up the section's head and first rows instead
// leaves room above or below it. The section itself stays on the page as it
// was; this only marks the part a step points at.
//
// The parent must be position: relative. height is in pixels from its top.
import React from "react";

function TourAnchor({ name, height }) {
  return (
    <div
      aria-hidden="true"
      data-tour={name}
      style={{ position: "absolute", top: 0, left: 0, right: 0, height, pointerEvents: "none" }}
    />
  );
}

export default TourAnchor;
